import { useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { gsap, prefersReducedMotion, transition, useGSAP } from '@/lib/gsap'

// Cortina vinho que sobe ao trocar de página.
// Ao abrir o site ela NÃO aparece: a página carrega direto.
function PageTransition() {
  const { pathname } = useLocation()
  const curtain = useRef(null)
  const lastPath = useRef(pathname)

  useGSAP(
    () => {
      // Mesmo endereço de antes = primeira abertura do site (ou recarregamento): sem cortina
      const isNavigation = lastPath.current !== pathname
      lastPath.current = pathname

      if (!isNavigation || prefersReducedMotion()) {
        transition.delay = 0
        return
      }

      transition.delay = 0.45
      gsap
        .timeline()
        .set(curtain.current, { autoAlpha: 1, yPercent: 0 })
        .to(curtain.current, { yPercent: -100, duration: 0.8, ease: 'expo.inOut' })
        .set(curtain.current, { autoAlpha: 0 })
    },
    { dependencies: [pathname], revertOnUpdate: true }
  )

  return (
    <div
      ref={curtain}
      aria-hidden="true"
      className="invisible pointer-events-none fixed inset-0 z-[60] bg-ink-texture"
    />
  )
}

export default PageTransition
